/**
 * 区域管理-楼栋列表
 */
import type { PageContext } from '@zto/zpage'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import dayjs from 'dayjs'
import { buildingDialog } from './_dialogs'
import { commonOptions } from '@/config'


export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/api/region/building/pageList',
        method: 'POST',
        // responseTransform: (res: any) => ({ data: res.list, total: res.total || 0 })
      },
      add: {
        label: '添加',
        api: '/sys/admin/api/region/building/create',
        method: 'POST',
        dialog: buildingDialog(false),
        successMessage: '添加成功'
      },
      edit: {
        label: '编辑',
        api: '/sys/admin/api/region/building/update',
        method: 'POST',
        dialog: buildingDialog(true),
        successMessage: '保存成功'
      },
      delete: {
        label: '删除',
        api: '/sys/admin/api/region/building/delete',
        method: 'POST',
        payload: { idList: ['${data.row.id}'] },
        message: '确认删除该楼栋吗？'
      },
      batchDelete: {
        label: '批量删除',
        api: '/sys/admin/api/region/building/delete',
        method: 'POST',
        message: '确认批量删除已选楼栋吗？',
        payload: async ({ app }: PageContext, ext: any) => {
          const { Message } = app.useMessage()
          const selectedRows = ext?.selection
          if (Array.isArray(selectedRows)) {
            // if (!app.getPageSearchData().isCheck) {
            //   Message.warning('请先按供应商进行筛选后再操作推送！')
            //   return false
            // }
            const len = selectedRows?.length
            if (!len) {
              Message.warning('请至少选择一条数据！')
              return false
            }

            const idList = selectedRows.map((it: any) => it?.id).filter(Boolean)
            return {
              idList
            }
          }
        }
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      labelWidth: 100,
      items: [
        {
          type: 'fuzzy-select',
          prop: 'communityCode',
          label: '小区',
          optionValueProp: 'communityCode',
          optionLabelProp: 'communityName',
          triggerFocus: true,
          remote: true,
          keywordProp: 'communityName',
          api:'/sys/admin/api/region/community/pageList',
          span: 6
        },
        { type: 'input', prop: 'buildingName', label: '楼栋号', span: 6 },
        { type: 'input', prop: 'unitName', label: '单元号', span: 6 }
      ]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }, { action: 'batchDelete' }]
    },
    table: {
      showCheckbox: true,
      operation: {
        width: 120,
        items: [{ action: 'edit' }, { action: 'delete' }]
      },
      innerAttrs: {
        operationPosition: 'left',
        noIndex: false,
      },
      columns: [
        { label: '小区编码', prop: 'communityCode', minWidth: 120 },
        { label: '小区名称', prop: 'communityName', minWidth: 150 },
        {
          label: '楼栋名称(楼栋号+单元)',
          minWidth: 160,
          formatter: (row: any) => {
            return [row?.buildingName || '', row?.unitName || ''].filter(Boolean).join('')
          }
        },
        {
          label: '最高楼层',
          minWidth: 100,
          formatter: (row: any) => (typeof row?.totalFloors === 'number' ? `${row.totalFloors}层` : '--')
        },
        {
          label: '电梯数量',
          minWidth: 100,
          formatter: (row: any) => (typeof row?.elevatorCount === 'number' ? `${row.elevatorCount}个` : '--')
        },
        {
          label: '是否机器车楼栋',
          prop: 'isMachineVehicleBuilding',
          minWidth: 130,
          formatter: { name: 'enumStr', options: 'yesOrNo' },
          // formatter: (row: any) => {
          //   return commonOptions.yesOrNo.find((it: any) => it.value === row.isMachineVehicleBuilding)?.label || '--'
          // }
        },
        {
          label: '创建时间',
          prop: 'gmtCreate',
          minWidth: 160,
          formatter: (row: any) => (row?.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--')
        }
      ]
    }
  }
}
